import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DepotToggleService {
    currentDepot$ = new BehaviorSubject(abp.setting.get('UserSettings.DepotAssociation.Depot') || '');
    updateCurrentDepot(depot: string) {
        this.currentDepot$.next(depot);
    }
}